const textCollator = new Intl.Collator(undefined, {
  sensitivity: "base",
  numeric: true,
});

function seriesName(book) {
  return String(book?.series || book?.book_series || "").trim();
}

function bookNumber(book) {
  const value = Number(book?.book_number);
  return Number.isFinite(value) && value > 0 ? value : null;
}

export default function sortBooksBySeries(books) {
  return [...books].sort((left, right) => {
    const leftSeries = seriesName(left);
    const rightSeries = seriesName(right);

    if (leftSeries && !rightSeries) return -1;
    if (!leftSeries && rightSeries) return 1;

    const seriesComparison = textCollator.compare(leftSeries, rightSeries);
    if (seriesComparison !== 0) return seriesComparison;

    const leftNumber = bookNumber(left);
    const rightNumber = bookNumber(right);

    if (leftNumber !== null && rightNumber === null) return -1;
    if (leftNumber === null && rightNumber !== null) return 1;
    if (leftNumber !== null && rightNumber !== null && leftNumber !== rightNumber) {
      return leftNumber - rightNumber;
    }

    return textCollator.compare(
      String(left?.title || ""),
      String(right?.title || "")
    );
  });
}
